import AppData from '@/mixins/appdata'
import SourceTypeEnum from '@/api/Enums/SourceTypeEnum'
import OrderTypeEnum from '@/api/Enums/OrderTypeEnum.js'

export default {
  data() {
    return {}
  },
  components: {},
  mixins    : [AppData],
  directives: {},
  watch     : {},
  methods   : {
    getOrderTypeById(id) {
      return this.orderTypesAll.find(orderType => parseInt(orderType.Id) === parseInt(id))
    },

    getOrderTypeName(order) {
      const orderType = this.getOrderTypeById(order.OrderTypeId)
      const isTableOrder = parseInt(order.SourceTypeId) === SourceTypeEnum.TABLE
      return isTableOrder ? this.$tc('Restaurant.Tables.Title', 1) : orderType ? orderType.Title : ''
    },

    getOrderTypeColor(order) {
      const orderType = this.getOrderTypeById(order.OrderTypeId)
      const isTableOrder = parseInt(order.SourceTypeId) === SourceTypeEnum.TABLE
      return orderType ? isTableOrder ? 'brown' : orderType.Color : ''
    },

    getOrderTypeIcon(order) {
      const orderType = this.getOrderTypeById(order.OrderTypeId)
      const isTableOrder = parseInt(order.SourceTypeId) === SourceTypeEnum.TABLE
      return orderType ? isTableOrder ? 'tab_unselected' : orderType.Icon : ''
    }
  },
  computed: {
    orderTypesAll() {
      const retVal = Object.values(this.$t('Order.Type.Item')).map(item => {
        if (item.Id === OrderTypeEnum.COLLECTION) item.Active = !!this.appConfig?.LOCATION_DATA?.OfferCollectionPos
        if (item.Id === OrderTypeEnum.DELIVERY) item.Active = !!this.appConfig?.LOCATION_DATA?.OfferDeliveryPos
        if (item.Id === OrderTypeEnum.SELF_SERVICE) item.Active = !!this.appConfig?.LOCATION_DATA?.OfferSelfServicePos
        return item
      })

      return retVal
    },

    orderTypes() {
      return this.orderTypesAll.filter(item => item.Active)
    }
  },
  created() {
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
  }

}
